import type { IModuleField } from '@/features/module-builder/types';
import { FieldTypeIcon } from './field-type-icon';
import { RecordFieldValue } from './record-field-value';

export interface RecordQuickViewProps {
    /** Fields to show, in order (e.g. `resolveLayout(module).quickViewFields`). */
    fields: IModuleField[];
    /** The record's `fieldSnapshot` (values keyed by field NAME). */
    snapshot: Record<string, unknown> | null;
}

/**
 * Compact label/value rows for record sheets and dialogs. Renders nothing when
 * no quick-view fields are configured.
 */
export function RecordQuickView({ fields, snapshot }: RecordQuickViewProps) {
    if (fields.length === 0) return null;

    return (
        <dl className="flex flex-col gap-3">
            {fields.map((field) => (
                <div key={field.id} className="flex flex-col gap-1">
                    <dt className="flex items-center gap-1.5 text-xs text-text-secondary">
                        <FieldTypeIcon fieldType={field.fieldType} className="size-3" />
                        {field.displayName}
                    </dt>
                    <dd className="min-w-0 text-sm">
                        <RecordFieldValue field={field} value={snapshot?.[field.name]} />
                    </dd>
                </div>
            ))}
        </dl>
    );
}
